<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingEffecten">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseEffecten" aria-expanded="false" aria-controls="collapseEffecten">
                Effecten
            </button>
        </h2>
        <div id="collapseEffecten" class="accordion-collapse collapse" aria-labelledby="headingEffecten"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Effecten (zoals aandelen, obligaties, beleggingsfondsen) worden voor de schenkbelasting gewaardeerd op
                de waarde in het economische verkeer op het moment van de schenking. Bij beursgenoteerde effecten wordt
                de slotkoers van de beursdag van overdracht als uitgangspunt genomen. Voor niet-beursgenoteerde aandelen
                is een professionele waardering vereist (bijv. DCF, intrinsieke waarde, multiples).
                <div class="space20"></div>
                Let op: bij overdracht van aanmerkelijk belang aandelen kan ook inkomstenbelasting verschuldigd zijn
                (box 2), of een conserverende aanslag worden opgelegd. De bedrijfsopvolgingsregeling (BOR) kan van
                toepassing zijn als het effectenbelang kwalificeert als ondernemingsvermogen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingEffecten2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseEffecten2" aria-expanded="false" aria-controls="collapseEffecten2">
                Soorten effecten
            </button>
        </h2>
        <div id="collapseEffecten2" class="accordion-collapse collapse" aria-labelledby="headingEffecten2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Effecten die geschonken worden, worden voor de schenkbelasting gewaardeerd op de waarde in het
                    economische verkeer op het moment van schenking. Hieronder een overzicht van de verschillende
                    soorten effecten:</p>

                <strong>Beursgenoteerde aandelen</strong><br>
                Aandelen die verhandeld worden op een effectenbeurs, zoals Euronext. Waardering vindt plaats op basis
                van de slotkoers op de dag van overdracht.<br><br>

                <strong>Niet genoteerde aandelen</strong><br>
                Aandelen in bv’s of andere besloten vennootschappen. Waardering vereist vaak een onafhankelijke
                bedrijfswaardering, zoals DCF of intrinsieke waarde.<br><br>

                <strong>Obligaties</strong><br>
                Schuldbewijzen met een vaste rente, uitgegeven door bijvoorbeeld bedrijven of overheden. De waarde is
                afhankelijk van rente, looptijd en marktontwikkelingen.<br><br>

                <strong>Overige effecten</strong><br>
                Overige verhandelbare financiële producten zoals opties, beleggingsfondsen (niet beursgenoteerd),
                converteerbare leningen en derivaten.
            </div>
        </div>
    </div>

</div>

